import { EVENT_REASON_PROMPT_ENTITY_ID } from 'constants/event-reason';
import { ApplicationRootState } from 'store/types';
import { EntityKind, EventReasonPromptPreference } from 'types/models/user-preference';

export const selectEventReasonPromptSnoozePreference = (
  state: ApplicationRootState
): EventReasonPromptPreference | undefined =>
  state.myPreferences[EntityKind.EVENT_REASON_PROMPT]?.[EVENT_REASON_PROMPT_ENTITY_ID];

export const selectPreferredIPCameraStreamId = (state: ApplicationRootState) => (ipCameraId: number) =>
  state.myPreferences[EntityKind.IP_CAMERA]?.[ipCameraId.toString()]?.streamId;

export const selectSamplePointPreference = (state: ApplicationRootState) => (samplePointSid: string) =>
  state.myPreferences[EntityKind.SAMPLE_POINT]?.[samplePointSid];